import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { BRAND } from "../../lib/constants";

const AdminLogin = () => {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(username, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1F4D2E] px-4">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-2xl">
        <div className="text-center mb-8">
          <img src={BRAND.logo} alt="logo" className="h-16 w-16 rounded-full object-cover ring-2 ring-[#C5A059] mx-auto bg-white" />
          <h1 className="font-serif font-bold text-2xl text-[#1C2B20] mt-4">Admin Portal</h1>
          <p className="text-sm text-[#5A6B5D] mt-1">Aarmira SuperNaturals</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#1C2B20] mb-1.5">Email</label>
            <input
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              data-testid="admin-username-input"
              className="w-full rounded-xl border border-[#E2DAD0] px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1F4D2E]"
              autoComplete="username"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C2B20] mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full rounded-xl border border-[#E2DAD0] px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1F4D2E]"
              autoComplete="current-password"
            />
          </div>
          {error && <p className="text-sm text-[#C86D51]" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full flex items-center justify-center gap-2 bg-[#1F4D2E] hover:bg-[#163A22] disabled:opacity-60 text-white font-medium rounded-full py-3 transition-colors"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
